import { Prefix, DianCompany } from '@shared-models';

import { IStorageCompany } from 'src/app/@interfaces/company.interface';
import { IPrefix } from 'src/app/@interfaces/prefix.interface';
import { IStore } from 'src/app/@interfaces/store.interface';

import { ContributorTypeMapper } from './contributor-type.mapper';
import { CountryMapper } from './country.mapper';
import { OrganizationTypeMapper } from './organization-type.mapper';

export class CompanyMapper {
  static mapper(prefix: IPrefix, company: IStorageCompany): DianCompany {
    return {
      Id_company: company.Id_company.toString(),
      name: company.name,
      organization_type: OrganizationTypeMapper.mapper(
        company.organization_type,
      ),
      NIT: company.NIT.split('-')[0],
      verification_digit: company.verification_digit,
      contributorType: ContributorTypeMapper.mapper(company.contributor_type),
      address: company.address,
      telephone: company.telephone,
      email: company.email,
      country: CountryMapper.mapper(company.countries),
      city: company.city,
      prefix: this.mapPrefix(prefix, company),
    };
  }

  private static mapPrefix(prefix: IPrefix, company: IStorageCompany): Prefix {
    return {
      id: prefix.id.toString(),
      id_company: company.Id_company.toString(),
      store: this.mapStore(prefix.store),
      prefix: prefix.prefix,
      voucher: prefix.voucher.toString(),
      invoice_authorization: prefix.invoice_authorization,
      authorization_start_date: prefix.authorization_start_date,
      authorization_end_date: prefix.authorization_end_date,
      prefix_from: prefix.prefix_from,
      prefix_to: prefix.prefix_to,
      numbering_range_key: prefix.numbering_range_key,
      commercial_registration_number: prefix.commercial_registration_number,
      software_id: prefix.software_id,
      software_pin: prefix.software_pin,
    };
  }

  private static mapStore(store: IStore) {
    return {
      name: store.name,
      address: store.address,
      city: store.city,
      country: CountryMapper.mapper(store.country),
    };
  }
}
